<template>
    <div>
        <el-dialog
                title="发放优惠券"
                width="80%"
                :visible.sync="isShowDialog"
                @close="closeDialog">
            <el-row class="plan selectBox" style="top: -20px" :gutter="22">

                <el-col :span='10'>
<!--                    <el-button @click='issue("oa")'>公众号推送</el-button>-->
                    <el-button @click='issue("email")'>发送邮件</el-button>
                    <el-button @click='copyLink()'>复制链接</el-button>
                </el-col>

                <el-col :span='4'>
                    <search-input v-model="search.nameId" placeholder="请输入名称/ID搜索" @change="handleQuery" />
                </el-col>

                <el-col :span='4'>
                    <search-input v-model="search.couponPrice" type="number" placeholder="请输入面额搜索" @change="handleQuery" />
                </el-col>

                <el-col :span='4'>
                    <el-select v-model="search.applicableProduct" clearable placeholder="选择适用产品筛选" @change="handleQuery">
                        <el-option
                                v-for="item in enumApplicableProduct"
                                :key="item.id"
                                :label="item.label"
                                :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-col>

            </el-row>

            <el-table :data='couponList' ref="couponList">
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column label='优惠券ID' prop='id' />
                <el-table-column label='优惠券名称' prop='couponName' />
                <el-table-column label='优惠券面额' prop='couponPrice'/>
                <el-table-column label='适用产品' prop='applicableProduct'>
                    <template slot-scope="scope">
                        {{statusChange(scope.row.applicableProduct)}}
                    </template>
                </el-table-column>
                <el-table-column label='优惠券类型' prop='couponType'>
                    <template slot-scope="scope">
                        {{statusChange(scope.row.couponType)}}
                    </template>
                </el-table-column>
                <el-table-column label='适用有效期' prop='endTime'>
                    <template slot-scope="scope">
                        {{validity(scope.row)}}
                    </template>
                </el-table-column>
              <el-table-column label='发放张数'>
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.couponNum" controls-position="right" :min="1" :max="9999"></el-input-number>
                </template>

              </el-table-column>

            </el-table>
            <!-- 分页区域 -->
            <paging :total="total"
                    :page.sync="queryInfo.current"
                    :limit.sync="queryInfo.size"
                    @pagination="getCouponList"></paging>
        </el-dialog>
    </div>
</template>

<script>

  import SearchInput from '@/components/common/searchInput/searchInput'
  import { getCouponsByType, issueSmsCouponBatch } from '@/api/coupon/coupon'
  import Paging from '@/components/common/paging/index'
  import { formatDate } from '@/js/momen'
  import { alert } from '@/utils/tips'
  import { enumApplicableProduct, enumStatus } from '@/js/enum'

  export default {
    name: 'issueCoupon',
    components: { Paging, SearchInput },
    data() {
      return {
        userInfo: [],
        total: 0,
        couponList: [],
        isShowDialog: false,
        search: {
          applicableTargets: ['ALL'],
        },
        queryInfo: {
          current: 1,
          size: 10
        },
        enumApplicableProduct
      }
    },
    props: {
    },
    created() {
    },
    methods: {
      // 状态码转换
      statusChange(p){
        let text = ''
        enumStatus.forEach(res => {
          if (p === res.key) {
            text = res.value
          }
        })
        return text
      },
      // 展示发放优惠券页面 单个发放时
      showDialog(list) {
        // 是否是VIP
        this.userInfo = list
        let vips = list.map(res => {
          return res.vip
        })
        // 添加条件
        if (vips.concat("YES")) {
          this.search.applicableTargets.push('VIP')
        }
        if (vips.concat("NO")) {
          this.search.applicableTargets.push('ORDINARY')
        }
        // 获取可发放的优惠券
        this.getCouponList()
        this.isShowDialog = true
      },
      // 关闭页面
      closeDialog() {
        this.isShowDialog = false
        this.couponList = []
      },
      handleQuery() {
        this.getCouponList()
      },
      validity(row) {
        return row?.couponType === 'TIME' ? formatDate(row.endTime,"yyyy-MM-dd hh:mm:ss") : '发放后' + row.effectiveDay + '天到期'
      },
      // 发放时发送邮件或者小程序通知 data优惠卷信息 type发送方式
      issue(type) {
        if (this.$refs.couponList.selection.length === 0) {
          alert("请先选择需要发放发优惠券。")
          return
        }
        if (type === 'email') {
          // 邮箱发送emailPush
          this.emailPush(type)
        } else {
          // 小程序推送OAPush
          this.OAPush(type)
        }
      },
      copyLink() {
        if (this.$refs.couponList.selection.length === 0) {
          alert("请先选择需要发放的优惠券。")
          return
        }
        if (this.userInfo.length !== 1) {
          alert("复制链接只能是对单人链接操作！")
          return
        }
        issueSmsCouponBatch(this.userInfo, this.$refs.couponList.selection, '').then((res) => {
          this.$copyText(res.data).then(() => {
            this.$message.success("复制成功！")
          })
        })
      },
      // 邮件发送
      emailPush(type){
        // 判断是否有邮件 没有的不予发送
        // 可发送的人
        let users = this.userInfo.filter(res => res.email !== null)
        // 不能此操作的人
        let noEmail = this.userInfo.filter(res => res.email === null).map(res => res.name).join(",")
        if (users.length > 0) {
          issueSmsCouponBatch(users, this.$refs.couponList.selection, type).then((res) => {
            if (noEmail.length > 0) {
              alert("用户" + noEmail + "没有邮件，不能通过邮件发送！其余人员已发送！")
            } else {
              alert("邮件推送成功！")
            }
          })
        } else {
          alert("选中的用户均没有邮件，不能通过邮件发送！")
        }
      },
      // 小程序发送
      OAPush(type){
        // 判断是否有订阅优惠券通知 没有的不予发送
        // 可发送的人
        let users = this.userInfo.filter(res => res.mpOpenid !== null)
        // 不能此操作的人
        let noOpenid = this.userInfo.filter(res => res.mpOpenid === null).map(res => res.name).join(",")
        if (users.length > 0) {
          issueSmsCouponBatch(users, this.$refs.couponList.selection, type).then((res) => {
            if (!noOpenid) {
              alert("用户" + noOpenid + "没有订阅优惠券推送，不能通过公众号发送！其余人员已发送！")
            } else {
              alert("公众号推送成功！")
            }
          })
        } else {
          alert("选中的用户均没有订阅优惠券推送，不能通过公众号发送！")
        }
      },
      // 查看优惠券
      getCouponList() {
        getCouponsByType(this.queryInfo, this.search).then(res => {
          this.couponList = res.code === '0' ? res.data.records : []
          for (let item of this.couponList) {
            item.couponNum = 1
          }
          this.total = res.data.total - 0
        })
      },
    }
  }
</script>

<style scoped>

</style>